import styled from 'styled-components';

export const UserReviewPrompt = styled.div`
  display: inline-block;
`;

export const FirstToReview = styled.p``;
